<template>
  <InnerCardInfo
    v-if="externalId !== null && externalId !== undefined"
    :label="label"
    :data="[
      {
        name: label,
        value: externalId || '-',
      },
    ]"
    ref="inner"
    :editReady="editReady"
  >
    <template slot="edit_block">
      <slot />
    </template>
  </InnerCardInfo>
</template>

<script>
import InnerCardInfo from './InnerCardInfo'

export default {
  name: 'ExternalIdPdf',
  props: {
    editReady: Boolean,
    externalId: [String, Number],
  },
  components: { InnerCardInfo },
  computed: {
    label() {
      return (
        this.localStorage?.translations?.pages?.common?.text?.worker_id ||
        'Worker ID'
      )
    },
  },
}
</script>
